import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow, Checkbox } from "@mui/material";
import { TextField } from "@totalsoft/rocket-ui";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import { isValid, getErrors } from "@totalsoft/pure-validations-react";
import { withParams } from "providers/ParamsConsumer";
import PhoneNumberField from "components/common/PhoneNumberTextField";

export const DealerContactDataRowComponent = ({
  idx,
  dealerContactInfo,
  onPropertyChange,
  params,
  validation,
  onRowSelectionChanged
}) => {
  const onCheckboxChanged = dealerContactInfo => event => {
    onRowSelectionChanged(dealerContactInfo.id, event.target.checked);
  };
  return (
    <>
      <TableRow>
        <TableCell colSpan={4} style={{ paddingRight: "70px" }}>
          <TextField
            id={"contactData_" + idx + "_personName"}
            name={"personName"}
            fullWidth
            value={dealerContactInfo.personName || ""}
            onChange={onPropertyChange("personName")}
          />
        </TableCell>

        <TableCell colSpan={4} style={{ paddingRight: "0px" }}>
          <TextField
            id={"contactData_" + idx + "_email"}
            name={"email"}
            fullWidth
            value={dealerContactInfo.email || ""}
            error={!isValid(validation.email)}
            helperText={getErrors(validation.email)}
            onChange={onPropertyChange("email")}
          />
        </TableCell>

        <TableCell colSpan={2} style={{ paddingRight: "0px", textAlign: "center" }}>
          <PhoneNumberField
            defaultCountry={params.defaultCountryCode}
            country={dealerContactInfo.phoneCountryCode}
            id={"contactData_" + idx + "_phone"}
            name={"phone"}
            fullWidth
            value={dealerContactInfo.phone || ""}
            onChange={onPropertyChange("phone")}
            error={!isValid(validation.phone)}
            helperText={getErrors(validation.phone)}
          />
        </TableCell>
        <TableCell colSpan={2} style={{ paddingRight: "0px", textAlign: "center" }}>
          <Checkbox
            id={"contactData_" + idx + "_default"}
            name={"isDefault"}
            checked={dealerContactInfo.isDefault || false}
            color="primary"
            onChange={onCheckboxChanged(dealerContactInfo)}
          />
        </TableCell>
        <TableCell colSpan={2} style={{ paddingRight: "0px", textAlign: "center" }}>
          <Checkbox
            id={"contactData_" + idx + "_active"}
            name={"isActive"}
            checked={dealerContactInfo.isActive || false}
            color="primary"
            onChange={onCheckBoxChange(onPropertyChange("isActive"))}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
DealerContactDataRowComponent.propTypes = {
  onPropertyChange: PropTypes.func,
  loadPartnerDetails: PropTypes.func,
  idx: PropTypes.number,
  dealerContactInfo: PropTypes.object.isRequired,
  params: PropTypes.object,
  validation: PropTypes.object.isRequired,
  check: PropTypes.bool,
  handleClick: PropTypes.func,
  onRowSelectionChanged: PropTypes.func
};
export default withParams(DealerContactDataRowComponent);
